
import "./navbar.css"
import { HashLink as Link } from "react-router-hash-link";
import { useState } from "react";

export const Navbar = () => {

  const [seeNav, setSeeNav] = useState(false)

  const handleSeeNav = () => {
    !seeNav? setSeeNav(true) : setSeeNav(false)
  }

  return (
    <nav className={ seeNav? 'navbar_after' : "navbar"} >


      <div className={ seeNav? "display_none" : "logo_bac"} onMouseEnter={handleSeeNav}>
        <h2 className='h2'>N</h2>

      </div>

      <div className={seeNav ? "display_block" : "display_none"} onMouseLeave={handleSeeNav}>

        <Link smooth to="#home">
          <button className='homeBtn' style={{ cursor: "pointer" }}>
            Home
          </button>
        </Link>

        <Link smooth to="#about">
          <button className='aboutBtn' style={{ cursor: "pointer" }}>

            About

          </button>
        </Link>

        <Link smooth to="#education">
          <button className='educationBtn'>
            Education
          </button>
        </Link>

        <Link smooth to="#skills">
          <button className='skillsBtn' style={{ cursor: "pointer" }}>

            Skills

          </button>
        </Link>

        <Link smooth to="#projects">
          <button className='projectsBtn' style={{ cursor: "pointer" }}>

            Projects

          </button>
        </Link>

        <Link smooth to="#contact">
          <button className='contactBtn' style={{ cursor: "pointer" }}>
            Contact
          </button>
        </Link>

      </div>


    </nav>
  )
}